(function (module) {
    'use strict';

    module.directive('ignoreDirty', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$setPristine = () => {
                };
                ctrl.$pristine = false;
            }
        };
    });

})(angular.module('rocket.components'));
